import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { initImgColorParams } from './store';
import { $tool } from '@/axios';
import store from '@/store';

// 上传本地图片
export const uploadImg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setImgColor', { ...state.imgcolor, loading: true });
    const { code, ...rest } = await $tool('color').post( 'upload', payload);
    const data = { ...rest, timestamp: Date.now() };
    commit('setImgColor', { data, loading: false });
    commit('setParams', { ...initImgColorParams });
  } catch (e) {
    commit('setImgColor', { data: null, loading: false });
    commit('setParams', { ...initImgColorParams });
    store.commit('common/setToast', { visible: true, text: '上传失败', timeout: 5000 });
  }
};

// 调整图片颜色参数
export const modifyImg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    const fd = payload as FormData;
    const { code, ...rest } = await $tool('color').post('paramadjust', payload);
    const data = { ...rest, timestamp: Date.now() };
    commit('setLoading', false);
    commit('setImgColor', { data, loading: false });
    commit('setParams', {
      imgKey: fd.get('imgKey'),
      colors: fd.get('colors'),
      brightAdjust: fd.get('brightAdjust'),
      saturationAdjust: fd.get('saturationAdjust'),
    });
  } catch (e) {
    commit('setLoading', false);
    commit('setImgColor', { data: null, loading: false });
    commit('setParams', { ...initImgColorParams });
    store.commit('common/setToast', { visible: true, text: '请求错误', timeout: 5000 });
  }
};
